import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { EDeviceModel } from 'src/app/conf/device-models';
import { RBE4_DEFAULT_OUTPUTS_STATUS, RBE4_OUTPUT_MASKS } from 'src/app/conf/rbe4';
import { Device } from 'src/app/model/device';
import { DeviceStatus } from 'src/app/model/device-status';
import { AppState } from 'src/app/store/app.reducer';
import { selectAutomationAlias, selectCurrentDevice, selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AutomationsAliasDialogComponent } from '../automations-alias-dialog/automations-alias-dialog.component';
import { AutomationsAlias, OutputsAlias } from 'src/app/model/automations-alias';

@Component({
	selector: 'app-outputs',
	templateUrl: './outputs.component.html',
	providers: [],
	styles: `
		:host ::ng-deep .p-panel-header {
			border: 1px solid #D5D5D5 !important;
			border-bottom: none !important;
		}
		:host ::ng-deep .p-panel-content {
			border: 1px solid #D5D5D5 !important;
		}
	`
})

export class OutputsComponent implements OnInit, OnDestroy {
	automationsAlias$: Observable<AutomationsAlias | undefined>;
	automationsAliasSub: Subscription | undefined;

	device$: Observable<Device | undefined>;
	deviceSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	device: Device = new Device();
	deviceStatus: DeviceStatus;
	deviceConfigured: boolean;

	OutputsAlias: OutputsAlias[];
	outputArray: boolean[] = [];
	ref: DynamicDialogRef | undefined;

	TYPE_ALIAS_OUTPUT = "TYPE_ALIAS_OUTPUT";

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
		public dialogService: DialogService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.device$ = this.store.select(selectCurrentDevice);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
		this.automationsAlias$ = this.store.select(selectAutomationAlias);
	}

	ngOnInit(): void {
		this.deviceStatusSub = this.deviceStatus$.pipe(filter(ds => !!ds)).subscribe(deviceStatus => {
			this.deviceStatus = deviceStatus;
			this.deviceConfigured = deviceStatus.Configured === 0;
			if (this.device !== undefined && this.device.ModelId !== undefined) {
				this.outputRbe();
			}
		});
		this.deviceSub = this.device$.pipe(filter(dm => !!dm))
			.subscribe(device => {
				this.device = device;
				if (this.deviceStatus !== undefined && this.deviceStatus.States !== undefined) {
					this.outputRbe();
				}
			});
		this.automationsAliasSub = this.automationsAlias$.subscribe(automationsAlias => {
			if (automationsAlias !== undefined && automationsAlias.Outputs !== undefined) {
				this.OutputsAlias = automationsAlias.Outputs;
			}
		});
	}

	outputRbe(): void {
		/*if (this.device!== undefined && this.device.ModelId !== undefined && this.device.ModelId === EDeviceModel.RBE24230)  {
			const states = this.deviceStatus.States;
			this.outputArray = RBE24230_DEFAULT_OUTPUTS_STATUS;
			if (states && states.length>0) {
				for (const state of states) {
					if (state.OperationId === 11  && state.Data.length > 0){
						let value = state.Data[0];
						const items: boolean[] = [];
						for (let i = 3; i >= 0; i--) {
							if (Math.floor(value/(2**i)) === 1 ){
								items.unshift(true);
								value = value - (2**i);
							} else {
								items.unshift(false);
							}
						}
						this.outputArray = items;
					}
				}
			}
		} else if (this.device!== undefined && this.device.ModelId !== undefined && this.device.ModelId === EDeviceModel.RBE24230)  {
			const os = this.deviceStatus.OutputsStatus;
			if (os) {
				//consider only first byte
				this.outputArray = this.splitData(os[0]);
			} else {
				this.outputArray = RBE4_DEFAULT_OUTPUTS_STATUS;
			}
		}*/
		if (this.device !== undefined && this.device.ModelId !== undefined) {
			const os = this.deviceStatus.OutputsStatus;
			if (os) {
				//consider only first byte
				this.outputArray = this.splitData(os[0]);
			} else {
				this.outputArray = RBE4_DEFAULT_OUTPUTS_STATUS;
			}
		}
	}

	ngOnDestroy(): void {
		this.deviceStatusSub?.unsubscribe();
		this.deviceSub?.unsubscribe();
		this.automationsAliasSub?.unsubscribe();
	}

	splitData(oByte: number): boolean[] {
		const arr: boolean[] = [];
		for (const mask of RBE4_OUTPUT_MASKS) {
			// eslint-disable-next-line no-bitwise
			arr.push((oByte & mask) !== 0);
		}
		return arr;
	}

	isRbe24230(): boolean {
		return this.device !== undefined && (this.device.ModelId === EDeviceModel.RBE24230 || this.device.ModelId === EDeviceModel.RBE230 ||
			this.device.ModelId === EDeviceModel.RBE24 || this.device.ModelId === EDeviceModel.GEN_RBE24230);
	}

	editAlias(): void {
		this.store.dispatch(DeviceActions.resetEditAutomationsAlias());
		this.ref = this.dialogService.open(AutomationsAliasDialogComponent, {
			header: this.translate.instant('OUTPUT_ALIAS'),
			width: '70vw',
			breakpoints: { '1250px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				typeAlias: this.TYPE_ALIAS_OUTPUT,

			}
		});
	}


	translateDataAlias(id: number): string {
		let resStr = '';
		if (this.OutputsAlias !== undefined) {
			for (const output of this.OutputsAlias) {
				if (output.Id === id) {
					resStr = this.translateData(output.Description);
				}
			}
		}
		return resStr;
	}


	translateData(str: string): string {
		let resStr = '';
		const fields = str.split('{');
		for (const field of fields) {
			if (field.indexOf('}') >= 0) {
				const toTranslate = field.split('}');
				resStr = resStr + this.translate.instant(toTranslate[0]) + toTranslate[1];
			} else {
				resStr = resStr + field;
			}
		}
		return resStr;
	}
}
